export default {
  namespaced: true,
  state: {
    maintainList: [] // 保养信息列表
  },
  actions: {
    // 新增保养信息
    async addMaintenance({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/organize/maintenance/info',
          data: data,
          msg: '新增保养信息成功'
        },
        { root: true }
      )
      return res
    },
    // 删除保养信息
    async deleteMaintenance({ dispatch }, uid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'DELETE',
          url: '/organize/maintenance/info',
          data: { uid: uid },
          msg: '删除保养信息成功'
        },
        { root: true }
      )
      return res
    },
    /* // 获取保养保险信息列表
    async getInsuranceList({ commit, dispatch }, uid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/person/cultivate/checklist',
          data: { eventUid: uid }
        },
        { root: true }
      )
      var maintainList = res.data ? res.data : []
      commit(
        'baseSet',
        { module: 'maintenance', key: 'maintainList', value: maintainList },
        { root: true }
      )
    }, */
    // 编辑保养信息
    async editMaintenance({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/organize/maintenance/info',
          data: data,
          msg: '编辑保养信息成功'
        },
        { root: true }
      )
      return res
    }
  }
}
